import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../../CommonComponents/OPL/Input/InputNumberMask';

export const HypotheticalReturn = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      name="accountPortfolio.hypotheticalReturn"
      render={({ field }) => (
        <InputNumberMask
          {...field}
          label="Straight-line Projected Return"
          rightIcon="far fa-percent"
          decimalScale={2}
          allowNegative={false}
          formVariant={errors.accountPortfolio?.hypotheticalReturn && 'error'}
          helperText={errors.accountPortfolio?.hypotheticalReturn?.message}
        />
      )}
    />
  );
};
